import { createFileRoute } from '@tanstack/react-router'
import { DashboardAuthGate } from '~/features/auth/dashboard-auth-gate'
import { CompanySetupPage } from '~/features/profile-setup/components/company-setup-page'

export const Route = createFileRoute('/setup/company')({
  component: SetupCompanyRoute,
})

function SetupCompanyRoute() {
  return (
    <DashboardAuthGate>
      <CompanySetupPage />
    </DashboardAuthGate>
  )
}
